module.exports = __webpack_public_path__ + "img/liwu-11@2x.ff1d4b62.png";